import { source as zh } from './zh';
import { source as en } from './en';

/* eslint-disable no-undef */
export const source = LANGUAGE === 'en' ? en : zh;
 